import React from "react";
import { Route, Routes } from "react-router-dom";

import RefundAllList from "../views/page/refund/AllList";
import RefundView from "../views/page/refund/RefundView";

function RouterRefund() {
  return (
    <>
      <Routes>
        <Route exact path="/History" element={<RefundAllList />} />
        <Route exact path="/View/:rd_seq" element={<RefundView />} />
      </Routes>
    </>
  );
}

export default RouterRefund;